<template>
	<div class="register">
		<div class="language-picker">
		    <span :class="{active: $store.state.globalLanguage === 'en'}" @click="setLanguage('en')">EN</span>
		    <span :class="{active: $store.state.globalLanguage === 'sv'}" @click="setLanguage('sv')">SV</span>
		</div>

		<div class="register-container mt-10" v-if=" ! thanks">
			<h2>GoCo Health Innovation City</h2>

			<h3 class="mt-5" v-html="__('register_under_title', 'Get access to the Smart Travel Habits platform by entering your information below')"></h3>

			<h4 class="mb-2 mt-10" :class="{hasError: errors.includes('firstName')}">{{ __('register_first_name', 'First name') }}</h4>
			<v-text-field hide-details solo v-model="firstName"></v-text-field>

			<h4 class="mb-2 mt-5" :class="{hasError: errors.includes('email')}">{{ __('register_email', 'E-mail') }}</h4>
			<v-text-field class="mb-8" hide-details solo v-model="email"></v-text-field>

			<div class="nudgd-btn inline survey-submit ml-10" @click="createEndUser()">
				{{ __('register_start_btn', 'Ja, nu börjar vi!') }}
			</div>

			<v-checkbox hide-details v-model="consent">
				<template v-slot:label>
					<span :class="{hasError: errors.includes('consent')}">
						<template v-if="__('register_consent')">
							<span v-html="__('register_consent')"></span>
						</template>

						<template v-if=" ! __('register_consent')">
							I consent to the processing of my personal data submitted in this form in accordance with Nudgd's <a href='https://nudgd.se/om-nudgd/integritetspolicy/' target='_blank'>privacy policy</a>.
						</template>
					</span>
				</template>
			</v-checkbox>
		</div>

		<div class="register-container mt-10" v-if="thanks">
			<h2>{{ __('register_thanks', 'Thank you!') }}</h2>

			<h3 class="mt-5">
				{{ __('register_under_thanks', 'Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.') }}
			</h3>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Vue',

	data() {
		return {
			firstName: null,
			email: null,
			consent: false,
			errors: [],
			thanks: false,
			processing: false
		}
	},

	mounted() {
		this.$store.state.loading = true
		this.$store.state.globalLanguage = 'sv'

		axios.get(this.$apiUrl + '/api/language/sv').then(res => {
			this.$store.state.translations = res.data.language
			this.$store.state.loading = false
		})
	},

	methods: {
		setLanguage(lang) {
		    this.$changeLang(lang)
		},

		createEndUser() {
			if (this.processing) {
				return
			}

			// validation
			this.errors = [
				this.firstName ? null : 'firstName',
				this.email ? null : 'email',
				this.consent ? null : 'consent',
			].filter(e => e)

			if (this.errors.length === 0) {
				this.thanks = true
				this.processing = true

				// api
				axios.post(this.$apiUrl + '/api/register', {
					firstName: this.firstName,
					email: this.email,
					clientId: 35,
					language: this.$store.state.globalLanguage
				}).then(() => {
					this.processing = false
					this.$metric({'event': 'registration_submit'})

				    // reset after 10 seconds
				    setTimeout(() => {
				    	this.thanks = false
				    	this.firstName = null
				    	this.email = null
				    	this.consent = false
				    }, 12000)
				})
			}
		}
	},
}
</script>
